import { useState, useEffect, useCallback } from 'react';
import { assemblyService } from 'services/api';
import InfoModal from './InfoModal';
import styles from './PostulacionModal.module.css';

const NOM_LABEL = {
  pendiente: { txt: 'En revisión del administrador', color: '#f79009' },
  aceptada:  { txt: 'Candidatura aceptada',          color: '#12b76a' },
  rechazada: { txt: 'Candidatura rechazada',         color: '#f04438' },
};

function CargoElegible({ assembly, pos, busy, setBusy, reload, setError }) {
  const [motiv, setMotiv] = useState('');
  const [form,  setForm]  = useState(false);
  const mine = pos.my_nomination;

  const act = async (fn) => {
    setBusy(true); setError('');
    try { await fn(); await reload(); }
    catch (e) { setError(e.response?.data?.message || 'No se pudo completar la acción.'); }
    finally { setBusy(false); }
  };

  return (
    <div className={styles.tarjetaCargo}>
      <div className={styles.cabeceraCargo}>
        <div className={styles.cargoTexto}>
          <div className={styles.cargoNombre}>{pos.name}</div>
          <div className={styles.cargoDetalle}>
            {pos.seats} puesto{pos.seats !== 1 ? 's' : ''}
            {pos.status === 'en_eleccion' && ' · votación en curso'}
            {pos.status === 'cerrado' && ' · elección cerrada'}
          </div>
        </div>
      </div>

      {/* Candidatos aceptados / ganadores */}
      {pos.candidates.length > 0 && (
        <div className={styles.listaCandidatos}>
          {pos.candidates.map(c => (
            <div key={c.id} className={styles.candidato}>
              <i className={`fas ${c.won ? 'fa-trophy' : 'fa-user'} ${c.won ? styles.trofeo : styles.usuario}`} />
              <span className={`${styles.candidatoNombre} ${c.won ? styles.pesoGano : styles.pesoNormal}`}>{c.candidate_name}</span>
              {pos.status === 'cerrado' && (
                <span className={c.won ? styles.resultadoGano : styles.resultadoPierde}>
                  {c.won ? 'GANÓ' : `${c.result_votes ?? 0} voto${c.result_votes === 1 ? '' : 's'}`}
                </span>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Estado / acción del propietario */}
      {pos.status === 'postulaciones' && (
        mine ? (
          <div className={styles.filaEstado}>
            <span className={styles.estadoPostulacion} style={{ '--tono': (NOM_LABEL[mine.status] || {}).color }}>
              <i className={`fas fa-circle ${styles.estadoPunto}`} />
              {(NOM_LABEL[mine.status] || {}).txt}
            </span>
            {mine.status === 'pendiente' && (
              <button className="btn btn-sm btn-secondary" disabled={busy}
                onClick={() => act(() => assemblyService.withdrawNomination(assembly.id, pos.id))}>
                Retirar postulación
              </button>
            )}
          </div>
        ) : form ? (
          <div className={styles.formulario}>
            <textarea className={`form-control ${styles.motivacion}`} rows="2" value={motiv} onChange={e => setMotiv(e.target.value)}
              placeholder="Motivación (opcional): por qué te postulas…" maxLength={2000} />
            <div className={styles.botonesFormulario}>
              <button className="btn btn-sm btn-primary" disabled={busy}
                onClick={() => act(async () => { await assemblyService.nominate(assembly.id, pos.id, { motivacion: motiv.trim() }); setForm(false); })}>
                <i className="fas fa-paper-plane" /> Enviar postulación
              </button>
              <button className="btn btn-sm btn-secondary" onClick={() => setForm(false)}>Cancelar</button>
            </div>
          </div>
        ) : (
          <button className={`btn btn-sm btn-primary ${styles.postular}`} onClick={() => setForm(true)}>
            <i className="fas fa-hand-point-up" /> Postularme a este cargo
          </button>
        )
      )}

      {pos.status === 'en_eleccion' && (
        <div className={styles.votacionAbierta}>
          <i className={`fas fa-check-to-slot ${styles.votacionIcono}`} />
          La votación está abierta — vota desde el botón <strong>“Pregunta activa”</strong>.
        </div>
      )}
    </div>
  );
}

export default function PostulacionModal({ assembly, onClose }) {
  const [positions, setPositions] = useState(null);
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try { const r = await assemblyService.positions(assembly.id); setPositions(r.data.positions || []); }
    catch (err) {
      setError(err.response?.status === 404
        ? 'Función no disponible — actualiza el servidor (falta la migración de Elecciones).'
        : (err.response?.data?.message || 'No se pudieron cargar las elecciones.'));
    }
  }, [assembly.id]);

  useEffect(() => { load(); }, [load]);

  return (
    <InfoModal title="Postularse" icon="fa-hand-point-up" color="#f04438" onClose={onClose}>
      <p className={styles.intro}>
        Cargos a elegir en la asamblea <strong>#{assembly.number_assembly}</strong>.
      </p>
      {error && (
        <div className={styles.error}
          onClick={() => setError('')}>{error}</div>
      )}
      {positions === null && !error ? (
        <div className={styles.cargando}><div className={`spinner ${styles.spinner}`} /></div>
      ) : positions && positions.length === 0 ? (
        <div className={styles.vacio}>
          <i className={`fas fa-inbox ${styles.iconoVacio}`} />
          Aún no hay cargos abiertos para postulación en esta asamblea.
        </div>
      ) : (
        <div className={styles.listaCargos}>
          {(positions || []).map(pos => (
            <CargoElegible key={pos.id} assembly={assembly} pos={pos}
              busy={busy} setBusy={setBusy} reload={load} setError={setError} />
          ))}
        </div>
      )}
    </InfoModal>
  );
}
